// The clock card while clock actions wait in the outbox: the last known day (GET /attendance/today)
// with the queued actions applied the way the server's `clock` applies them — the running block
// ends at the new time and the new block starts there (STOP only ends). The server stays the
// authority: once the actions are synced the real day replaces this view. Pure, no imports
// (test/offline/clockOverlay.test.js).

const STATUS_AFTER = {
  WORK: "CHECKED_IN",
  BREAK: "ON_BREAK",
  TRAVEL: "TRAVELLING",
  STOP: "CHECKED_OUT"
};

// The calendar day of a time in a time zone, "YYYY-MM-DD"
const dayOf = (time, timeZone) => {
  try {
    return new Intl.DateTimeFormat("en-CA", { timeZone }).format(new Date(time));
  } catch {
    return new Date(time).toISOString().slice(0, 10);
  }
};

/**
 * day: the `data` of GET /attendance/today (segments, status, day …) or null
 * actions: queued clock bodies in order: { action, at (ISO), project, paid, note }
 */
export function applyClockActions(day, actions, { timeZone = "Europe/Berlin" } = {}) {
  if (!actions.length) return day;
  let result = {
    ...(day || { segments: [], status: "NOT_STARTED", flatBreakMinutes: 0 }),
    segments: ((day && day.segments) || []).map(segment => ({ ...segment }))
  };
  for (const { action, at, project, paid, note } of actions) {
    if (!STATUS_AFTER[action]) continue;
    const time = new Date(at).toISOString();
    let running = result.segments.find(segment => !segment.end);
    // A finished day is not continued by a start on a later day: that is a new day
    if (!running && result.day && result.day !== dayOf(time, timeZone)) {
      result = {
        ...result,
        _id: null,
        day: dayOf(time, timeZone),
        segments: [],
        summary: undefined
      };
      running = null;
    }
    if (running) running.end = time;
    if (action !== "STOP") {
      result.segments.push({
        type: action,
        start: time,
        end: null,
        project: project || null,
        ...(action === "TRAVEL" ? { paid: paid !== false } : {}),
        note: note || "",
        source: "CLOCK",
        pending: true
      });
    }
    result.status = STATUS_AFTER[action];
    if (!result.day) result.day = dayOf(time, timeZone);
  }
  result.pendingSync = true;
  return result;
}
